/**
 * Explains why a question bank editor is read-only.
 *
 * Without this the disabled fields look like a broken page rather than a
 * permission decision.
 */
import React from 'react';
import { Lock } from 'lucide-react';

export function QuestionBankReadOnlyBanner({ testId }) {
  return (
    <div
      className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900"
      role="status"
      data-testid={testId}
    >
      <Lock className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <p>
        <span className="font-semibold">View only.</span>{' '}
        Your role does not have permission to edit this question bank. Ask an
        administrator to grant it from Administration &rarr; Roles &amp; Permissions.
      </p>
    </div>
  );
}

export default QuestionBankReadOnlyBanner;
